import { CloseRounded } from "@mui/icons-material";
import {
  Dialog,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useMemo } from "react";

import Flx from "../layout/Flx";
import Htag from "../typography/Htag";
import ModalContent from "./components/ModalContent";

const offset = 24;
const SideCardModal = ({
  show,
  onClose,
  title,
  children,

  drawerWidth = "800px",
  suppressBodyPadding,
  suppressBodyOverflow,
  bodySx,

  maxWidth = false,
  headerSx,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = (_event, reason) => {
    onClose(false);
  };
  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        maxWidth={maxWidth}
        PaperProps={{
          sx: {
            width: isMobile ? "100%" : drawerWidth,
            borderRadius: isMobile ? "0" : "4px",
            m: 0,
            position: "absolute",
            maxWidth: isMobile ? "100%" : "54vw",
            // maxWidth: isMobile ? "100%" : "36vw",
            minWidth: isMobile ? "100%" : "500px",
            height: isMobile ? "100%" : `calc(100% - ${offset * 1}px)`,
            maxHeight: isMobile ? "100%" : `calc(100% - ${offset * 1}px)`,

            right: isMobile ? 0 : offset / 2,
            top: isMobile ? 0 : offset / 2,
          },
        }}
      >
        <Header sx={headerSx} title={title} onClose={handleClose} />
        <Body
          suppressBodyPadding={suppressBodyPadding}
          suppressBodyOverflow={suppressBodyOverflow}
          sx={bodySx}
        >
          {children}
        </Body>
      </Dialog>
    </>
  );
};

const Header = ({ title, onClose, sx }) => {
  const rootHeaderStyles = useMemo(() => {
    let sty = {
      position: "relative",
      overflow: "hidden",
      flexGrow: 0,
      flexShrink: 0,
      borderBottom: "1px solid #f2f2f2",
      padding: "20px 44px 16px 24px",
      // pr: 1.5,
      // py: 1.5,
      // borderBottom: `1px solid ${grey[300]}`,
      // boxShadow: `0 1px 2px ${shadow1},0 -1px ${mediaInnerBorder} inset,0 2px 1px -1px ${shadowInset} inset`,
    };

    return {
      ...sty,
      ...sx,
    };
  }, [sx]);
  return (
    <>
      <ModalContent sx={rootHeaderStyles}>
        <Flx fw jb ac>
          <Htag
            //
            // h1
            h2
            sx={{ lineHeight: 1, fontSize: "20px", fontWeight: 800 }}
          >
            {title}
          </Htag>

          <Flx ac g={0}>
            <Tooltip title={"Close"} arrow>
              <IconButton
                // color="primary"
                size="small"
                sx={{
                  position: "absolute",
                  top: "14px",
                  right: "14px",
                  borderRadius: "4px",
                }}
                onClick={() => onClose(false)}
              >
                <CloseRounded />
              </IconButton>
            </Tooltip>
          </Flx>
        </Flx>
      </ModalContent>
    </>
  );
};

const Body = ({ children, suppressBodyPadding, suppressBodyOverflow, sx }) => {
  const styles = useMemo(() => {
    let sty = { position: "relative" };

    if (suppressBodyPadding) {
      sty = { ...sty, padding: 0 };
    }
    if (suppressBodyOverflow) {
      sty = { ...sty, overflow: "hidden" };
    }
    return {
      ...sty,
      ...sx,
    };
  }, [sx, suppressBodyPadding, suppressBodyOverflow]);
  return (
    <>
      <ModalContent sx={styles}>{children}</ModalContent>
    </>
  );
};

export default SideCardModal;
